export enum FinSobSidePanelSettingStatus {
  Completed = 'Completed',
  NotCompleted = 'NotCompleted',
}
